export const colors = {
    success: "text-emerald-900",
    error: "text-red-900",
    warning: "text-amber-900",
    info: "text-blue-700",
    default: ""
}
